import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import ListItemText from '@mui/material/ListItemText';
import Autocomplete from '@mui/material/Autocomplete';

export default function AutocompleteSelect(props) {
  const {
    id,
    options,
    currentlySelected,
    disabled = false,
  } = props;

  const shallowComparison = (a, b) => {
    if (typeof a !== 'object' || typeof b !== 'object') return (a === b);

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) {
      return false;
    }

    return keysA.every((key) => a[key] === b[key]);
  };

  let initialValue = '';
  const idName = `${id}_control`;

  options.forEach((rowToCompare) => {
    if (initialValue === '' || shallowComparison(rowToCompare.id, currentlySelected)) initialValue = rowToCompare;
  });

  const [selectedValue, setSelectedValue] = useState(initialValue);

  return (
    <>
      <Autocomplete
        disablePortal
        id={idName}
        options={options}
        value={selectedValue}
        disabled={disabled}
        disableClearable
        onChange={(e, value) => {
          setSelectedValue(value);
          $(document.getElementById(idName)).val(value.label);
          $(document.getElementById(idName)).trigger('change');
        }}
        isOptionEqualToValue={(option, value) => shallowComparison(option.id, value.id)}
        renderInput={(params) => (
          <TextField
            {...params}
          />
        )}
        renderOption={(option, item) => (
          <li {...option} key={item.key}>
            <ListItemText>{item.label}</ListItemText>
          </li>
        )}
      />
      <input type="hidden" id={id} name={id} value={JSON.stringify(selectedValue.id)} />
    </>
  );
}
